import { useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { authCheck } from 'modules/auth/store/actions';
import { useAuth } from './use-auth';

export const useAuthGuard = () => {
  const dispatch = useDispatch();
  const { isAuthed, isChecking } = useAuth();
  const location = useLocation();

  // Memoize the fromPath value to prevent unnecessary re-renders
  const fromPath = useMemo(() => {
    return `${location.pathname}${location.hash}${location.search}`;
  }, [location.pathname, location.hash, location.search]);

  useEffect(() => {
    if (!isAuthed && !isChecking) {
      dispatch(authCheck(fromPath));
    }
  }, [isAuthed, isChecking, dispatch, fromPath]);
};
